import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Table, CardTitle } from "reactstrap"
import { getUserTickets } from "../../../helpers/repository"
import axios from "axios"
import { API_URL } from "../../../constants/constants"
export default function ReferAFriend(props) {
  const [earning, setEarning] = useState()
  const call = () => {
    axios({
      method: "get",
      url: `${API_URL}/client/get-raf-earning/${props.userId}`,
    })
      .then(res => {
        setEarning(res?.data?.data)
      })
      .catch(e => {})
  }
  useEffect(() => {
    call()
  }, [props.userId])
  return (
    <Col lg={6}>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Refer-A-Friend Commission</CardTitle>

          <div className="row mb-4">
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="text-nowrap">Date Paid</th>
                      <th className="text-nowrap">No. Referrals</th>
                      <th className="text-nowrap">Total Paid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {earning?.map((item, i) => (
                      <>
                        <tr key={i}>
                          <td>{item?.day}</td>
                          <td>{item?.uid}</td>
                          <td>{item?.paid_amount}</td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </Table>
              </div>
              {/* <p className="text-muted fw-medium col-form-label">
                No Available Messages
              </p> */}
            </Col>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}
